import { StepValue } from 'pages/CreateUniProfilePage/types';

export const showAvaTipSteps = [StepValue.PROFILE, StepValue.HEALTHCARE_EXPERIENCE, StepValue.EDUCATION, StepValue.ADDITIONAL_INFORMATION, StepValue.PRACTICE];
